export default __webpack_public_path__ + "static/media/WWG_News_Icon.c64e89ec.svg";